module.exports = __webpack_public_path__ + "img/banner-xs.dce050c8.jpg";